export enum ResponseStatusCode {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
  CONFLICT = 409,
}

interface IHttpErrorBase {
  message: string;
}

export interface IHttpErrorBadRequest {
  statusCode: ResponseStatusCode.BAD_REQUEST;
  error: string;
  message: any;
}

export interface IHttpErrorUnauthorized extends IHttpErrorBase {
  statusCode: ResponseStatusCode.UNAUTHORIZED;
}

export interface IHttpCreated extends IHttpErrorBase {
  statusCode: ResponseStatusCode.CREATED;
}

export interface IHttpErrorConflict extends IHttpErrorBase {
  statusCode: ResponseStatusCode.CONFLICT;
}
